<template>
	<el-drawer 
		:visible.sync="showDetail" 
		title="小组详情管理" 
		size="80%"
		ref="drawer"
		:before-close="beforeClose"
	>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane :disabled="disabled" label="打卡详情" name="1">打卡详情</el-tab-pane>
			<el-tab-pane :disabled="disabled" label="小组设置" name="2">
				<create 
					:close="close" 
					:fetchList="fetchList"
					ref="create"
				></create>
			</el-tab-pane>
			<el-tab-pane :disabled="disabled" label="小组简介" name="3">
				<brief 
					:detail="detail"
					:close="close" 
					:fetchList="fetchList"
				></brief>
			</el-tab-pane>
			<el-tab-pane :disabled="disabled" label="读书币设置" name="4">
				<coin
					:detail="detail"
					:close="close" 
					:fetchList="fetchList"
				></coin>
			</el-tab-pane>
			<el-tab-pane :disabled="disabled" label="审核管理" name="5">
				<audit
					:detail="detail"
					:close="close" 
					:fetchList="fetchList"
				></audit>
			</el-tab-pane>
			<el-tab-pane :disabled="disabled" label="学员管理" name="6">
				<user
					:detail="detail"
					:close="close" 
					:fetchList="fetchList"
				></user>
			</el-tab-pane>
		</el-tabs>
	</el-drawer>
</template>

<script type="text/javascript">
import Create from './create.vue';
import Brief from './brief.vue';
import Coin from './coin.vue';
import User from './user.vue';
import Audit from './audit.vue';

export default {
	data() {
		return {
			activeName: '1',
			showDetail: false,
			disabled: false,
			detail: {}
		}
	},
	components: {
		Create,
		Brief,
		Coin,
		User,
		Audit
	},
	props: {
		fetchList: Function
	},
	methods: {
		show(activeName, row, type) {

			this.detail = row
			this.activeName = activeName
			this.showDetail = true

			if (type == 'create' || type == 'copy') {
				this.disabled = true
			}

			this.$nextTick(() => {
				if (type == 'detail' || type == 'copy') {
					this.$refs.create.show(row, type)
				}
				if (type == 'create') {
					this.$refs.create.show()
				}
			})
		},
		close() {
			this.$refs.drawer.closeDrawer()
		},
		beforeClose(done) {
			this.disabled = false

			// this.$refs.create.resetForm()


			this.$nextTick(() => {
				done()
			})
		},
		handleClick() {
			console.log(this.activeName)
		}
	}
}
</script>

<style lang="less" >
.el-drawer__body {
	padding: 0 20px 20px;
}
</style>